import { TextField } from "@mui/material";
import { DatePicker, DatePickerToolbar } from "@mui/x-date-pickers";

const DatePickerComponent = ({ value, onChange, ...props }) => {
  return (
    <DatePicker
      label=""
      value={value}
      onChange={onChange}
      disabled={props.disabled}
      format="DD/MM/YYYY"
      inputFormat="DD/MM/YYYY"
      renderInput={(params) => <TextField {...params} />}
      size="small"
      slotProps={{
        toolbar: {
          toolbarFormat: "DD/MM/YYYY",
          toolbarPlaceholder: "Select a date...",
        },
      }}
      sx={{
        flex: 1.5,
        "& .MuiInputBase-input": {
          pl: 1,
          pr: 0,
          py: 0.3,
          fontWeight: 600,
          ...props.inputStyle,
        },
        "& .MuiIconButton-root.Mui-disabled": {
          color: "transparent!important",
        },
        "& .MuiOutlinedInput-input.Mui-disabled": {
          WebkitTextFillColor: "#000",
        },
        "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
          borderColor: "transparent!important",
        },
        "& .MuiDatePickerToolbar-title": {
          fontSize: "14px",
        },
        ...props.sx,
      }}
    />
  );
};
export default DatePickerComponent;
